import React from 'react';
import { useTranslation } from 'react-i18next';

interface UISettingsProps {
  hideExampleProjects: boolean;
  measurementPointsOnHover: boolean;
  muteNotificationSound: boolean;
  onHideExampleProjectsChange: (value: boolean) => void;
  onMeasurementPointsOnHoverChange: (value: boolean) => void;
  onMuteNotificationSoundChange: (value: boolean) => void;
}

export const UISettings: React.FC<UISettingsProps> = ({
  hideExampleProjects,
  measurementPointsOnHover,
  muteNotificationSound,
  onHideExampleProjectsChange,
  onMeasurementPointsOnHoverChange,
  onMuteNotificationSoundChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col lg:flex-row min-h-[486px] border-b border-greyP5 p-4 md:p-8">
      <div className="w-full lg:w-[30%] lg:pr-8 mb-6 lg:mb-0">
        <div className="flex flex-col items-center">
          <div className="p-0 lg:p-5 text-white text-sm md:text-md w-full">
            <p>{t('settings.ui.description')}</p>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[70%] lg:pl-8">
        <div>
          <div className="flex justify-between items-center py-5 border-b border-greyP4 gap-4">
            <div className="flex flex-col">
              <span className="text-white text-sm md:text-md font-medium">{t('settings.ui.hideExampleProjects')}</span>
              <span className="text-gray-500 text-xs mt-1">{t('settings.ui.hideExampleProjectsHint')}</span>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={hideExampleProjects}
                onChange={(e) => onHideExampleProjectsChange(e.target.checked)}
                className="w-5 h-5 accent-green01 cursor-pointer"
              />
            </div>
          </div>

          <div className="flex justify-between items-center py-5 border-b border-greyP4 gap-4">
            <div className="flex flex-col">
              <span className="text-white text-sm md:text-md font-medium">
                {t('settings.ui.measurementPointsOnHover')}
              </span>
              <span className="text-gray-500 text-xs mt-1">{t('settings.ui.measurementPointsOnHoverHint')}</span>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={measurementPointsOnHover}
                onChange={(e) => onMeasurementPointsOnHoverChange(e.target.checked)}
                className="w-5 h-5 accent-green01 cursor-pointer"
              />
            </div>
          </div>

          <div className="flex justify-between items-center py-5 border-b border-greyP4 gap-4">
            <div className="flex flex-col">
              <span className="text-white text-sm md:text-md font-medium">
                {t('settings.ui.muteNotificationSound')}
              </span>
              <span className="text-gray-500 text-xs mt-1">{t('settings.ui.muteNotificationSoundHint')}</span>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={muteNotificationSound}
                onChange={(e) => onMuteNotificationSoundChange(e.target.checked)}
                className="w-5 h-5 accent-green01 cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
